export default __webpack_public_path__ + "static/media/sip-picturemark-l.2378452c.svg";